import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const _socialInstagram: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 85 85'>
        <title>Instagram</title>
        <g id='Circle_Color' data-name='Circle Color'>
            <g id='Instagram'>
                <circle id='back' fill='#d50060' cx='42.5' cy='42.5' r='42.5' />
                <path
                    fill='#fff'
                    d='M42.5,23c6.35,0,7.11,0,9.62.14a12.93,12.93,0,0,1,4.42.82,7.91,7.91,0,0,1,4.51,4.51,12.93,12.93,0,0,1,.82,4.42c.12,2.51.14,3.27.14,9.62s0,7.11-.14,9.62a12.93,12.93,0,0,1-.82,4.42,7.91,7.91,0,0,1-4.51,4.51,12.93,12.93,0,0,1-4.42.82c-2.51.12-3.26.14-9.62.14s-7.11,0-9.62-.14a12.93,12.93,0,0,1-4.42-.82A7.91,7.91,0,0,1,24,56.54a12.93,12.93,0,0,1-.82-4.42C23,49.61,23,48.85,23,42.5s0-7.11.14-9.62A12.93,12.93,0,0,1,24,28.46,7.91,7.91,0,0,1,28.46,24a12.93,12.93,0,0,1,4.42-.82C35.39,23,36.15,23,42.5,23m0-4.29c-6.46,0-7.27,0-9.81.14A17.49,17.49,0,0,0,26.91,20a12.1,12.1,0,0,0-7,7,17.49,17.49,0,0,0-1.11,5.78c-.11,2.54-.14,3.35-.14,9.81s0,7.27.14,9.81A17.49,17.49,0,0,0,20,58.09a12.1,12.1,0,0,0,7,7,17.49,17.49,0,0,0,5.78,1.11c2.54.11,3.35.14,9.81.14s7.27,0,9.81-.14a17.49,17.49,0,0,0,5.78-1.11,12.1,12.1,0,0,0,7-7,17.49,17.49,0,0,0,1.11-5.78c.11-2.54.14-3.35.14-9.81s0-7.27-.14-9.81a17.49,17.49,0,0,0-1.11-5.78,12.1,12.1,0,0,0-7-7,17.49,17.49,0,0,0-5.78-1.11c-2.54-.11-3.35-.14-9.81-.14Z'
                />
                <path
                    fill='#fff'
                    d='M42.5,30.28A12.22,12.22,0,1,0,54.72,42.5,12.22,12.22,0,0,0,42.5,30.28Zm0,20.15a7.93,7.93,0,1,1,7.93-7.93A7.93,7.93,0,0,1,42.5,50.43Z'
                />
                <circle fill='#fff' cx='55.2' cy='29.8' r='2.86' />
            </g>
        </g>
    </svg>
);

const SocialInstagram = styled(_socialInstagram)``;

export default SocialInstagram;
